module.exports = __webpack_public_path__ + "static/img/5.97217ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/product/5.jpg
// module id = +OuC
// module chunks = 1